import {DomainEvent} from './DomainEvent';
import {Profile} from '../resources/Profile';

export class ProfileUpdated extends DomainEvent<Profile> {}
